import type { DashboardOrder } from '../model/order.types'
import type { OrdersBoardColumn } from '@/widgets/orders-board/OrdersBoard.types'

/**
 * Filters dashboard orders into columns based on column state definitions.
 * @param dashboardOrders - Record of status to DashboardOrder array
 * @param columns - Array of OrdersBoardColumn definitions
 * @returns Record mapping column IDs to arrays of DashboardOrder
 */
export function filterOrdersByColumns(
  dashboardOrders: Record<string, DashboardOrder[]>,
  columns: OrdersBoardColumn[],
): Record<string, DashboardOrder[]> {
  if (!dashboardOrders || Object.keys(dashboardOrders).length === 0) {
    return {}
  }

  const result: Record<string, DashboardOrder[]> = {}

  columns.forEach((column) => {
    const columnStates = column.states || []

    if (columnStates.length > 0) {
      result[column.id] = Object.entries(dashboardOrders)
        .flatMap(([state, orders]) =>
          columnStates.includes(state) ? orders : [],
        )
    } else if (column.name) {
      result[column.id] = dashboardOrders[column.name] || []
    } else {
      result[column.id] = []
    }
  })

  return result
}
